import { Button, JsonInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle, IconLoader } from '@tabler/icons-react';
import { useProjectId } from '~/hooks/context/useProjectId';
import { api } from '~/trpc-extra/api';

export function JSONImport() {
  const projectId = useProjectId();
  const trpcUtils = api.useUtils();
  const { mutateAsync: importTestDefinition, isPending } = api.test.importTestDefinition.useMutation({
    onMutate: () => {
      notifications.show({
        color: 'blue',
        title: 'Importing test definition',
        message: 'Please wait while we import the test definition',
        icon: <IconLoader size="1rem" />,
      });
    },
    onSuccess: async () => {
      notifications.show({
        color: 'green',
        title: 'Success',
        message: 'Test definition imported successfully',
        icon: <IconCheck size="1rem" />,
      });
      modals.closeAll();
      await trpcUtils.test.listTests.invalidate({ projectId: projectId! });
    },
    onError: (e) => {
      console.error(e);
      notifications.show({
        color: 'red',
        title: 'Error',
        message: 'Issue while importing test definition',
        icon: <IconExclamationCircle size="1rem" />,
      });
    },
  });
  const form = useForm({
    initialValues: {
      testDefinition: '',
    },
  });

  return (
    <form
      className="flex flex-col gap-4"
      onSubmit={form.onSubmit(async ({ testDefinition }) => {
        const definition = JSON.parse(testDefinition);
        await importTestDefinition({
          testCreationParams: definition,
          projectId: projectId!,
        });
      })}
    >
      <JsonInput
        className="space-y-4"
        autosize
        formatOnBlur
        minRows={20}
        maxRows={20}
        placeholder='{ "name": "my test", ... }'
        {...form.getInputProps('testDefinition')}
      />
      <div className="flex justify-end">
        <div className="flex flex-row gap-2">
          <Button variant="outline">Validate</Button>
          <Button
            type="submit"
            loading={isPending}
          >
            Import
          </Button>
        </div>
      </div>
    </form>
  );
}
